import React, { useState } from "react";
import { styled } from "@mui/material";
import MainChart from "components/charts/MainChart";
import DashCards from "components/dashboardCards/DashCards";

const DashboardPage = () => {

  return (
    <StyledDiv>
      <DashCards />
      <MainChart />
    </StyledDiv>
  );
};

export default DashboardPage;

const StyledDiv = styled("div")({
  "& .body": {
    overflow: "auto",
    height: "100%",
    width: "100%",
    margin: 0,
    padding: "16px 16px",
  },
  "& .card": {
    width: "25%",
    height: "25%",
  },
});
